import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { PageRoutes } from "../../../constants/routes";
import { UserTemporaryRequestBody } from "../../../core/api/requests/auth/temporary/types";
import { ErrorMessageManager } from "../../../core/http/ErrorMessageManager";
import { appActions } from "../../../ducks/app";
import { authActions, AuthType } from "../../../ducks/auth";
import { TwilioChannelType } from "../../../ducks/external";
import { useNavigation } from "../../../hooks/useNavigation";
import { useRecaptcha } from "../../../hooks/useRecaptcha";
import { useTwilio } from "../../../hooks/useTwilio";

export const useCustomerInfo = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();
  const { checkRecaptcha } = useRecaptcha();
  const { sendTwilioCode } = useTwilio();

  const handleCustomerInfo = useCallback(
    (type: AuthType, value: string) => {
      dispatch(appActions.showLoading());

      const body: UserTemporaryRequestBody = {};
      const channel: TwilioChannelType =
        type === AuthType.Email
          ? TwilioChannelType.Email
          : TwilioChannelType.Sms;
      if (type === AuthType.Email) {
        body.email = value;
      } else if (type === AuthType.PhoneNumber) {
        body.tel = value;
      }

      checkRecaptcha(
        () => {
          sendTwilioCode(
            channel,
            value,
            () => {
              dispatch(
                authActions.sendRegistrationEmail.started({
                  ...body,
                  onComplete: () => dispatch(appActions.hideLoading()),
                  onSuccess: (key) => {
                    dispatch(
                      appActions.showModal.started({
                        title:
                          "認証コードを送信しました。メールまたは、携帯電話のSMSをご確認ください。",
                        nextButtonLabel: "閉じる",
                        handleNext: () => dispatch(appActions.closeModal()),
                      }),
                    );
                    navigateToPage(
                      PageRoutes.CUSTOMER_INFO_AUTH.replace(
                        ":type",
                        type.valueOf(),
                      ).replace(":value", value),
                      false,
                      { key },
                    );
                  },
                }),
              );
            },
            () => dispatch(appActions.hideLoading()),
          );
        },
        () => {
          dispatch(appActions.hideLoading());
          dispatch(
            appActions.showModal.started({
              title: ErrorMessageManager.Instance.getErrorMessage("RECA-0001"),
              nextButtonLabel: "閉じる",
              handleNext: () => dispatch(appActions.closeModal()),
            }),
          );
        },
      );
    },
    [checkRecaptcha, sendTwilioCode],
  );

  const handleSendEmail = useCallback(
    (email: string, emailConfirmation: string) => {
      dispatch(appActions.showLoading());

      checkRecaptcha(
        () => {
          dispatch(
            authActions.sendRegistrationEmailOnly.started({
              email,
              email_confirmation: emailConfirmation,
              accepted: true,
              // TODO: change to selected langugage
              lang: "ja",
              onComplete: () => dispatch(appActions.hideLoading()),
              onSuccess: () => navigateToPage(PageRoutes.REGISTRATION_MESSAGE),
            }),
          );
        },
        () => {
          dispatch(appActions.hideLoading());
          dispatch(
            appActions.showModal.started({
              title: ErrorMessageManager.Instance.getErrorMessage("RECA-0001"),
              nextButtonLabel: "閉じる",
              handleNext: () => dispatch(appActions.closeModal()),
            }),
          );
        },
      );
    },
    [],
  );

  return { handleCustomerInfo, handleSendEmail };
};
